import Modal from 'react-bootstrap/Modal'
import Carousel from 'react-bootstrap/Carousel'
import { Button, Image } from 'react-bootstrap'
import { TailSpin } from 'react-loader-spinner'
import { Link } from 'react-router-dom'

const ModalSlider = ({ show, onHide, loader, popupData }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
      className={`${loader && 'custom-class-modalslider'}`}
      backdrop="static"
      style={{paddingLeft: 0}}
    >
      {loader && (
        <TailSpin
          height='50'
          width='50'
          color='#4fa94d'
          ariaLabel='tail-spin-loading'
          radius='1'
          visible={true}
          wrapperStyle={{ padding: 14 }}
        />
      )}
      {!loader && (
        <>
          <Carousel>
            {popupData.map((carousel) => (
              <Carousel.Item key={carousel.id}>
                {carousel.link && (
                  <Link to={carousel.link} target='_blank'>
                    <Image
                      className='d-block w-100'
                      src={carousel.image}
                      alt={`image ${carousel.order}`}
                    />
                  </Link>
                )}
                {!carousel.link && (
                  <Image
                    className='d-block w-100'
                    src={carousel.image}
                    alt={`image ${carousel.order}`}
                  />
                )}
              </Carousel.Item>
            ))}
          </Carousel>
          <Button
            variant='success'
            style={{ width: 250, position: 'absolute', bottom: -60, right: 0 }}
            onClick={onHide}
          >
            Accept
          </Button>
        </>
      )}
    </Modal>
  )
}

export default ModalSlider
